export const USER_ROUTE_NAMES = {
  NOTIFICATION_PREFERENCES: 'notification-preferences',
  PROFILE_EDIT: 'profile-edit',
  REFERRALS_REPORT: 'referrals-report',
};
